import { Box, Button, HStack, Icon, ScrollView, Typography } from "components/ui";
import { H3, Paragraph } from "components/ui/Typography";
import { X } from "lucide-react-native";
import React, { useRef } from "react";
import Modal from "react-native-modal";
import { useGetCompanyLocationsQuery } from "store/abcoApi";

interface CartPickupLocationModalProps {
	isVisible: boolean;
	onClose: () => void;
	onLocationSelect: (location: any) => void;
	cartId: number;
	selectedLocationId?: number;
}

export function CartPickupLocationModal({ isVisible, onClose, onLocationSelect, cartId, selectedLocationId }: CartPickupLocationModalProps) {
	const scrollViewRef = useRef(null);
	const { data: locations, isLoading: isLoadingLocations } = useGetCompanyLocationsQuery();

	return (
		<Modal animationIn={"fadeIn"} animationOut={"fadeOut"} scrollOffset={1} onBackdropPress={onClose} isVisible={isVisible}>
			<Box bg="$basicwhite" overflow="hidden" borderRadius={12} height={700}>
				<HStack alignItems="center" justifyContent="space-between" bg="$lighttealxlight" paddingHorizontal={28} paddingVertical={20}>
					<H3>Select Pickup Location</H3>
					<Box>
						<Button onPress={onClose} gap={6}>
							<Icon as={X} />
							<Typography>Close</Typography>
						</Button>
					</Box>
				</HStack>

				<ScrollView sx={{ width: "100%", height: 400, padding: 28 }} ref={scrollViewRef}>
					<Box gap={16}>
						<Paragraph>Select a location where you would like to pick up your order:</Paragraph>
						{isLoadingLocations ? (
							<Paragraph>Loading locations...</Paragraph>
						) : (
							<Box gap={12}>
								{locations?.map((location) => (
									<Button key={location.id} variant={selectedLocationId === location.id ? "primary-light" : "outline"} borderRadius={12} paddingVertical={12} onPress={() => onLocationSelect(location)}>
										<Box width="100%" alignItems="flex-start">
											<Typography
												sx={{
													color: selectedLocationId === location.id ? "$basicwhite" : "$primarylight",
												}}
												weight="bold"
											>
												{location.name}
											</Typography>
										</Box>
									</Button>
								))}
							</Box>
						)}
					</Box>
				</ScrollView>
			</Box>
		</Modal>
	);
}
